import classNames from 'classnames'
import { ReactNode, useContext } from 'react'

import { PopupPositionContext } from 'core-components/library/popup/context/PopupPositionContext'
import { TPopupVertical } from 'core-components/library/popup/interface/position'

import styles from './PopPaper.module.scss'

interface IProps {
  className?: string
  style?: object
  children: ReactNode
  shadowPosition?: 'auto' | 'bottom' | 'top'
}

export const PopPaper = ({ children, className, style, shadowPosition = 'bottom' }: IProps) => {
  const PositionContext = useContext(PopupPositionContext)
  const direction = PositionContext.direction.vertical
  const calcShadowClass = () => {
    if (shadowPosition === 'bottom') {
      return styles.directionBottom
    }
    if (shadowPosition === 'top') {
      return styles.directionTop
    }
    return direction === TPopupVertical.Bottom ? styles.directionBottom : styles.directionTop
  }

  return (
    <div
      tabIndex={1}
      className={classNames(styles.root, calcShadowClass(), className || '')}
      style={style}
      data-testid={'popPaper'}
    >
      {children}
    </div>
  )
}
